import React, { useContext } from 'react';

import PageContext from '../../Context/PageContext';
import { Rnd } from 'react-rnd';

import $ from "jquery";
import { calcItemPositionByMoveCard, calcMoveCardPosition } from '../../Util/ElemUtil';
import { Button } from '@blueprintjs/core';
import { isMobile } from 'react-device-detect';

const StyloCard = (props: any) => {

  const { zoomValue, setZoomValue, selectedItem, objItems, selectedItemIsLock } = useContext(PageContext);

  const rndCloneRef = React.useRef<Rnd | null>(null);

  const val = props.val;

  //devrait etre calculé par rapport au zoom ??
  const maxWidthORHeightCorner = isMobile ? 150 : 100;
  const sizeMoveCard = isMobile ? 30 / zoomValue : 30 / zoomValue;

  const [editText, setEditText] = React.useState(false);

  function selectElement(event: React.MouseEvent<HTMLElement>) {
    setEditText(!editText);
  }

  return (
    <div id={'stylo-' + val.id} className="stylo-edition"
      style={{
        visibility : (selectedItemIsLock ? 'hidden' : 'visible'),
        left: calcMoveCardPosition(null, val, zoomValue, null, null, "stylocard").x,
        top: calcMoveCardPosition(null, val, zoomValue, null, null, "stylocard").y,
        width: sizeMoveCard,
        height: sizeMoveCard,
        padding: isMobile ? 30 : 20,
        borderRadius: '50%',
        backgroundColor: 'white',
        boxShadow: 'rgba(57, 76, 96, 0.15) 0px 0px 4px 1px, rgba(43, 59, 74, 0.3) 0px 0px 0px 1px',
        zIndex: 999999,
        position: 'absolute'
      }}
      //data={editText}
      data-is={editText}
      onClick={ selectElement}
    >
      <img className="img-move-card" src={editText ? process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/pencil-blue.svg" : process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/pencil-no.svg"}></img>
    </div>
  );
};

export default StyloCard;